import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://61c7d3b1576be4e54b8bded1af5f3bed@sentry.kapturecrm.com/21",
  integrations: [
    new Sentry.reactRouterV6BrowserTracingIntegration({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["https://mvcruise.designcan.in/guest-portal/"],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.4, //  Capture 40% of the transactions
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
